export default "__VITE_ASSET__CildLfc$__"